module.exports = __webpack_public_path__ + "static/media/pioneer-bank.683e507d.gif";